export class RouteUtil {
  public static currentRoute(page: string, routes: any) {
      const keys = Object.keys(routes).filter(k => typeof routes[k as any] === 'string');
      const values = keys.filter(k => {
        if (routes[k as any] === page) {
          return k;
        }
      });
      return routes[values[0]];
  }
}
